import type { Occupation } from "@/common/types/occupation";
import { getOccupations } from "@/services/occupations";
import { create } from "zustand";

export interface OccupationState {
  occupations: Occupation[];
  loading: boolean;
  error: boolean;
  getOccupations: () => Occupation[];
  fetchAndSetOccupations: () => Promise<void>;
}

export const useOccupationsStore = create<OccupationState>()((set, get) => ({
  occupations: [],
  loading: false,
  error: false,

  getOccupations: (): Occupation[] => get().occupations,

  fetchAndSetOccupations: async (): Promise<void> => {
    set({ loading: true, error: false });
    try {
      const occupations = await getOccupations();
      set({ occupations, loading: false });
    } catch {
      set({ occupations: [], loading: false, error: true });
    }
  },
}));
